export default "__VITE_ASSET__qb2a9wlk__"